import styled from 'styled-components';
import Tooltip from './Tooltip';
import { colorSchema } from 'utils/style';

export default styled(Tooltip)`
  .tooltip {
    display: flex;
    position: relative;

    &__button {
      background: none;
      border: 0;
      cursor: pointer;
      outline: none;

      svg {
        fill: ${colorSchema('error900')};
      }
    }

    &__tooltip {
      background: ${colorSchema('white')};
      border-radius: 8px;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
      color: ${colorSchema('grey900')};
      font-size: 1.6rem;
      position: absolute;
      padding: 1rem;
      text-transform: none;
      min-width: 300px;
      top: 2.5rem;
      z-index: 1;
    }
  }
`;
